// @ts-nocheck
/*
 * Port of voice-library/add-moh.js (220 lines). BYTE-IDENTICAL.
 * Single-file upload for MOH (.mp3/.wav only). Incoming type is
 * auto-approved by backend; outgoing waits for admin review.
 * v1 LottieAnimation success modal â†’ react-bootstrap Modal kept, Lottie
 * dropped for the same reason as GroupSettingsPage (LottieAnimation is
 * a v1-only component and v2 uses react-toastify for feedback).
 */
import React, { useState } from 'react';
import { Card as ShadCard } from '@/components/ui/card';
import { Button as _ShadButton } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const _cx = (...args: any[]) => args.filter(Boolean).join(' ');
const Container: any = ({ fluid, className, children, ...props }: any) => (
  <div className={_cx(fluid ? 'container-fluid' : 'container', className)} {...props}>
    {children}
  </div>
);
const Row: any = ({ className, children, ...props }: any) => (
  <div className={_cx('row', className)} {...props}>
    {children}
  </div>
);
const _colCls = ({ xs, sm, md, lg, xl }: any) => {
  const parts = [];
  if (md) parts.push(`col-md-${md}`);
  if (lg) parts.push(`col-lg-${lg}`);
  if (xl) parts.push(`col-xl-${xl}`);
  if (sm) parts.push(`col-sm-${sm}`);
  if (xs) parts.push(`col-${xs}`);
  if (!parts.length) parts.push('col');
  return parts.join(' ');
};
const Col: any = ({ xs, sm, md, lg, xl, className, children, ...props }: any) => (
  <div className={_cx(_colCls({ xs, sm, md, lg, xl }), className)} {...props}>
    {children}
  </div>
);
const _btnVariantMap: Record<string, any> = {
  primary: 'default',
  secondary: 'outline',
  danger: 'destructive',
  light: 'outline',
  link: 'link',
};
const Button: any = ({ variant, size, className, children, ...props }: any) => {
  let mapped = variant;
  if (typeof variant === 'string') {
    if (variant.startsWith('outline-')) mapped = 'outline';
    else if (_btnVariantMap[variant]) mapped = _btnVariantMap[variant];
    else if (variant.startsWith('btn ')) mapped = 'default';
  }
  return (
    <_ShadButton variant={mapped} size={size} className={className} {...props}>
      {children}
    </_ShadButton>
  );
};
const Card: any = ({ className, children, ...props }: any) => (
  <ShadCard className={className} {...props}>
    {children}
  </ShadCard>
);
Card.Header = ({ className, children, ...props }: any) => (
  <div className={_cx('card-header', className)} {...props}>
    {children}
  </div>
);
Card.Body = ({ className, children, ...props }: any) => (
  <div className={_cx('card-body', className)} {...props}>
    {children}
  </div>
);
Card.Title = ({ as: As = 'h5', className, children, ...props }: any) => (
  <As className={_cx('card-title', className)} {...props}>
    {children}
  </As>
);
Card.Text = ({ className, children, ...props }: any) => (
  <p className={_cx('card-text', className)} {...props}>
    {children}
  </p>
);
Card.Footer = ({ className, children, ...props }: any) => (
  <div className={_cx('card-footer', className)} {...props}>
    {children}
  </div>
);
const Form: any = ({ children, onSubmit, className, ...props }: any) => (
  <form
    className={className}
    onSubmit={onSubmit || ((e: any) => e.preventDefault())}
    {...props}
  >
    {children}
  </form>
);
Form.Group = ({ className, controlId: _c, children, ...props }: any) => (
  <div className={_cx('mb-3', className)} {...props}>
    {children}
  </div>
);
Form.Label = ({ className, children, htmlFor, ...props }: any) => (
  <label className={_cx('form-label', className)} htmlFor={htmlFor} {...props}>
    {children}
  </label>
);
Form.Control = ({ as, className, children, isInvalid, ...props }: any) => {
  const cls = _cx('form-control', isInvalid && 'is-invalid', className);
  if (as === 'select')
    return (
      <select className={cls} {...props}>
        {children}
      </select>
    );
  if (as === 'textarea') return <textarea className={cls} {...props} />;
  return <input className={cls} {...props} />;
};
Form.Select = ({ className, children, isInvalid, ...props }: any) => (
  <select
    className={_cx('form-control form-select', isInvalid && 'is-invalid', className)}
    {...props}
  >
    {children}
  </select>
);
Form.Check = ({
  type = 'checkbox',
  label,
  id,
  className,
  inline,
  children,
  ...props
}: any) => (
  <div className={_cx('form-check', inline && 'form-check-inline', className)}>
    <input type={type} id={id} className="form-check-input" {...props} />
    {label !== undefined && (
      <label htmlFor={id} className="form-check-label">
        {label}
      </label>
    )}
    {children}
  </div>
);
Form.Text = ({ muted, className, children, ...props }: any) => (
  <small className={_cx('form-text', muted && 'text-muted', className)} {...props}>
    {children}
  </small>
);
const Modal: any = ({ show, onHide, size, centered: _c, children, className, ...props }: any) => {
  const sizeCls =
    size === 'sm'
      ? 'sm:max-w-md'
      : size === 'lg'
      ? 'sm:max-w-2xl'
      : size === 'xl'
      ? 'sm:max-w-6xl'
      : '';
  return (
    <Dialog open={!!show} onOpenChange={(o: boolean) => !o && onHide?.()}>
      <DialogContent
        className={`${sizeCls} max-h-[90vh] overflow-y-auto ${className || ''}`.trim()}
        {...props}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};
Modal.Header = ({ children, closeButton: _cb, className, ...props }: any) => (
  <DialogHeader className={className} {...props}>
    {children}
  </DialogHeader>
);
Modal.Title = ({ children, className, ...props }: any) => (
  <DialogTitle className={className} {...props}>
    {children}
  </DialogTitle>
);
Modal.Body = ({ children, className, ...props }: any) => (
  <div className={`overflow-x-auto ${className || ''}`.trim()} {...props}>
    {children}
  </div>
);
Modal.Footer = ({ children, className, ...props }: any) => (
  <DialogFooter className={className} {...props}>
    {children}
  </DialogFooter>
);
const Table: any = ({
  bordered,
  striped,
  hover,
  responsive: _r,
  className,
  children,
  ...props
}: any) => (
  <table
    className={_cx(
      'table',
      bordered && 'table-bordered',
      striped && 'table-striped',
      hover && 'table-hover',
      className,
    )}
    {...props}
  >
    {children}
  </table>
);
const _TabsCtx = React.createContext<any>({});
const Tabs: any = ({
  activeKey,
  defaultActiveKey,
  onSelect,
  children,
  className,
  ...props
}: any) => {
  const [internalKey, setInternalKey] = React.useState(defaultActiveKey || null);
  const current = activeKey !== undefined ? activeKey : internalKey;
  const handle = (k: any) => {
    if (activeKey === undefined) setInternalKey(k);
    onSelect?.(k);
  };
  const tabs = React.Children.toArray(children).filter(Boolean) as any[];
  if (current === null && tabs.length) {
    setInternalKey(tabs[0]?.props?.eventKey);
  }
  return (
    <_TabsCtx.Provider value={{ current, setKey: handle }}>
      <div className={className} {...props}>
        <ul className="nav nav-tabs" role="tablist">
          {tabs.map((t: any) => (
            <li key={t.props.eventKey} className="nav-item" role="presentation">
              <button
                type="button"
                className={_cx('nav-link', current === t.props.eventKey && 'active')}
                onClick={() => handle(t.props.eventKey)}
                disabled={t.props.disabled}
              >
                {t.props.title}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content">
          {tabs.map((t: any) => (
            <div
              key={t.props.eventKey}
              className={_cx('tab-pane', current === t.props.eventKey && 'active show')}
              style={{ display: current === t.props.eventKey ? undefined : 'none' }}
            >
              {t.props.children}
            </div>
          ))}
        </div>
      </div>
    </_TabsCtx.Provider>
  );
};
const Tab: any = () => null;
const Tooltip: any = ({ children, id: _id, ...props }: any) => (
  <span {...props}>{children}</span>
);
const OverlayTrigger: any = ({ children, overlay, placement: _p, trigger: _t }: any) => {
  let title = '';
  if (overlay?.props?.children) {
    title =
      typeof overlay.props.children === 'string'
        ? overlay.props.children
        : Array.isArray(overlay.props.children)
          ? overlay.props.children.filter((c: any) => typeof c === 'string').join(' ')
          : '';
  }
  return React.cloneElement(children, { title });
};
const Badge: any = ({ bg, pill, className, children, ...props }: any) => (
  <span
    className={_cx('badge', bg && `bg-${bg}`, pill && 'rounded-pill', className)}
    {...props}
  >
    {children}
  </span>
);
const Spinner: any = ({ animation: _a, size, variant, className, ...props }: any) => (
  <span
    className={_cx(
      'spinner-border',
      size === 'sm' && 'spinner-border-sm',
      variant && `text-${variant}`,
      className,
    )}
    role="status"
    aria-hidden="true"
    {...props}
  />
);
import { toast } from 'sonner';
import { friendlyApiError } from '@/utilities/apiErrorMessage';
import { useNavigate } from 'react-router-dom';

import { postApiMediaCall } from '@/service/httpCall';
import { API_MOH_CREATE } from '@/service/url';
import { ROUTES } from '@/utilities/constant';
import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { Button as PageButton } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Music, Upload, Loader2 } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';

const NAME_REGEX = /^[a-zA-Z0-9_-]+$/;

import { canUploadMoh } from '@/utilities/promptUploadAccess';
import { UploadNotPermitted } from '@/components/feedback/UploadNotPermitted';

const AddMoh = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState<File | null>(null);
  const [mohName, setMohName] = useState('');
  const [mohType, setMohType] = useState('outgoing');
  const [nameError, setNameError] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [showToastModal, setShowToastModal] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const showToasts = (msg: string) => {
    toast.success(msg);
  };

  const validateName = (val: string) => {
    if (!val || val.trim() === '') {
      setNameError('MOH name is required');
      return false;
    }
    if (val.includes(' ')) {
      setNameError('MOH name cannot contain spaces');
      return false;
    }
    if (!NAME_REGEX.test(val)) {
      setNameError('Only letters, numbers, underscore (_) and hyphen (-) allowed');
      return false;
    }
    setNameError('');
    return true;
  };

  const handleNameChange = (e: any) => {
    const v = e.target.value;
    setMohName(v);
    if (v.trim() !== '') validateName(v);
    else setNameError('');
  };

  const handleFileChange = (e: any) => {
    const f = e.target.files?.[0] || null;
    if (f) {
      const ext = f.name.toLowerCase().slice(f.name.lastIndexOf('.'));
      if (!['.mp3', '.wav'].includes(ext)) {
        toast.error('Only .mp3 or .wav files allowed');
        e.target.value = '';
        setFile(null);
        return;
      }
    }
    setFile(f);
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a .mp3 or .wav file');
      return;
    }
    if (!validateName(mohName)) {
      toast.error('Please fix the MOH name errors before uploading');
      return;
    }
    if (!['incoming', 'outgoing'].includes(mohType)) {
      toast.error('Invalid MOH type');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('moh_name', mohName.trim());
    formData.append('moh_type', mohType);

    try {
      setIsUploading(true);
      await postApiMediaCall(API_MOH_CREATE, formData);
      const msg =
        mohType === 'incoming'
          ? 'MOH file uploaded successfully (auto-approved).'
          : 'MOH file uploaded successfully. Please wait for Admin Approval.';
      showToasts(msg);
      setTimeout(() => navigate(`/${ROUTES.VOICE_LIBRARY.MOH_MANAGEMENT}`), 1500);
    } catch (err: any) {
      toast.error(friendlyApiError(err));
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <ScrollPage>
      <PageHeader
        title="Upload MOH File"
        description="Add a hold-music file for playback during calls."
        actions={
          <PageButton
            variant="outline"
            size="sm"
            onClick={() => navigate(`/${ROUTES.VOICE_LIBRARY.MOH_MANAGEMENT}`)}
            className="gap-1.5"
          >
            <ArrowLeft className="h-4 w-4" />
            Back
          </PageButton>
        }
      />

      <div className="mt-4 rounded-lg border border-border/60 bg-card p-4 shadow-neu-raised">
        <div className="mb-4 flex items-center justify-between gap-3 border-b border-border/60 pb-3">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary/10 text-primary">
              <Music className="h-4 w-4" />
            </span>
            <div>
              <div className="text-sm font-semibold text-foreground">
                MOH File Details
              </div>
              <div className="text-xs text-muted-foreground">
                Fields marked with <span className="text-destructive">*</span> are required
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={(e) => e.preventDefault()} className="space-y-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="space-y-1.5">
              <label htmlFor="uploadFile" className="text-sm font-medium text-foreground">
                Upload WAV or MP3 File <span className="text-destructive">*</span>
              </label>
              <input
                type="file"
                id="uploadFile"
                accept=".wav,.mp3,audio/wav,audio/mpeg"
                onChange={handleFileChange}
                className="block w-full rounded-md border border-input bg-card text-sm text-foreground file:mr-3 file:cursor-pointer file:border-0 file:border-r file:border-border/60 file:bg-primary/10 file:px-3 file:py-2 file:text-sm file:font-medium file:text-primary hover:file:bg-primary/15"
              />
            </div>

            <div className="space-y-1.5">
              <label htmlFor="mohName" className="text-sm font-medium text-foreground">
                MOH Name <span className="text-destructive">*</span>
              </label>
              <Input
                type="text"
                id="mohName"
                value={mohName}
                onChange={handleNameChange}
                onKeyDown={(e) => {
                  if (e.key === ' ') e.preventDefault();
                }}
                onBlur={() => validateName(mohName)}
                placeholder={
                  nameError
                    ? 'Invalid name'
                    : 'MOH Name (letters, numbers, _, - only)'
                }
                className={nameError ? 'border-destructive' : ''}
              />
              {nameError && (
                <div className="text-xs text-destructive">{nameError}</div>
              )}
            </div>
          </div>

          <div className="md:w-1/2">
            <div className="space-y-1.5">
              <label htmlFor="mohType" className="text-sm font-medium text-foreground">
                MOH Type <span className="text-destructive">*</span>
              </label>
              <Select value={mohType || undefined} onValueChange={setMohType}>
                <SelectTrigger id="mohType" className="h-10 w-full">
                  <SelectValue placeholder="Select MOH type…" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="outgoing">Outgoing</SelectItem>
                  <SelectItem value="incoming">Incoming</SelectItem>
                </SelectContent>
              </Select>
              <div className="text-xs text-muted-foreground">
                Incoming type skips the approval step.
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-2 border-t border-border/60 pt-4">
            <PageButton
              asChild
              variant="ghost"
              size="sm"
              onClick={() => navigate(`/${ROUTES.VOICE_LIBRARY.MOH_MANAGEMENT}`)}
            >
              <span>Cancel</span>
            </PageButton>
            <PageButton
              onClick={handleUpload}
              disabled={isUploading}
              type="button"
              size="sm"
              className="gap-1.5"
            >
              {isUploading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Upload className="h-4 w-4" />
              )}
              {isUploading ? 'Uploading…' : 'Upload MOH'}
            </PageButton>
          </div>
        </form>
      </div>
    </ScrollPage>
  );
};

const AddMohGuarded = () => {
  if (!canUploadMoh()) {
    return <UploadNotPermitted title="Add MOH" what="MOH files" />;
  }

  return <AddMoh />;
};

export default AddMohGuarded;
